import { render, staticRenderFns } from "./FileNewAction.vue?vue&type=template&id=2dafbd72&scoped=true"
import script from "./FileNewAction.vue?vue&type=script&lang=js"
export * from "./FileNewAction.vue?vue&type=script&lang=js"
import style0 from "./FileNewAction.vue?vue&type=style&index=0&id=2dafbd72&prod&lang=css"
import style1 from "./FileNewAction.vue?vue&type=style&index=1&id=2dafbd72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dafbd72",
  null
  
)

export default component.exports